<template>
  <div class="col-12">
    <div class="text-left box-content border-dark">
      <div v-if="showErrors" class="row">
        <div class="col-12">
          <div class="text-danger border border-danger m-4">
            {{ showErrors }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="row">
            <div class="col-12">
              <h4 class="border-dark border-bottom">
                {{ $t('お客様情報') }}
              </h4>
            </div>
          </div>
          <div id="names-input" class="row mt-2">
            <div v-if="enableName" class="col-12">
              <div class="form-box">
                <div class="form-group">
                  <div class="form-control-static design1 mb-2">
                    <template v-if="this.$root.serviceSetting.User.id === '1'">
                      <i class="fas fa-user"></i> {{ $t('利用者氏名') }}
                    </template>
                    <template v-else>
                      <i class="fas fa-user"></i> {{ $t('message.name') }}
                    </template>
                  </div>
                  <div class="col">
                    <div class="design1" v-if="!this.$store.state.isCRMMember">{{ $t("姓カナ") }} *</div>
                    <input
                        v-model="params.last_name"
                        type="text"
                        class="form-control mr-3 design1"
                        data-layout="kana"
                        :readonly="this.$root.$route.query.dev == 'tab2'"
                        @focus="show">
                    <div
                        v-for="(e, index) in showInputError('first_name')"
                        :key="'error-first_name-' + index"
                        class="text-danger">
                      {{ $t(e.message) }}
                    </div>
                  </div>
                  <div class="col" v-if="!this.$store.state.isCRMMember">
                    <div class="design1">{{ $t("名カナ") }} *</div>
                    <input
                        v-model="params.first_name"
                        type="text"
                        class="form-control design1"
                        data-layout="kana"
                        :readonly="this.$root.$route.query.dev == 'tab2'"
                        @focus="show">
                    <div
                        v-for="(e, index) in showInputError('last_name')"
                        :key="'error-last_name-' + index"
                        class="text-danger">
                      {{ $t(e.message) }}
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-control-static design1 mb-2">
                    <i class="fas fa-user"></i> {{ $t('性別') }}
                  </div>
                  <div class="btn-group-m1 d-flex">
                    <button
                        v-for="i in this.selectOptions.sex"
                        class="flex-fill"
                        :key="'sex-'+i"
                        :class="{btn: true, 'btn-light': params.sex != i, 'btn-info': params.sex == i}"
                        :value="i"
                        @click="updateSex">
                      {{ $t('message.sex' + i) }}
                    </button>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-control-static design1 mb-2">
                    <i class="fas fa-user"></i> {{ $t('年代') }}
                  </div>
                  <div class="btn-group-m1" v-if="$root.serviceSetting.input_type_age.value === 'button'">
                    <button
                        v-for="i in this.selectOptions.ages"
                        :key="'age-'+i"
                        :class="{btn: true, 'btn-light': params.age != i, 'btn-info': params.age == i}"
                        :value="i"
                        @click="updateAge">
                      {{ $t($t('message.age' + i)) }}
                    </button>
                  </div>
                  <div class="btn-group-m1" v-else>
                    <select @change="updateAge" class="form-control">
                      <option>
                        選択してください
                      </option>
                      <option
                          v-for="i in this.selectOptions.ages"
                          class="dropdown-item btn-block"
                          :key="'age-'+i"
                          :class="{btn: true, 'btn-light': params.age != i, 'btn-info': params.age == i}"
                          :value="i"
                          :selected="params.age === i" >
                        {{i}} {{ $t('歳') }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-control-static design1 mb-2">
                    <i class="fas fa-user"></i> {{ $t('身長') }}
                  </div>
                  <div class="form-inline">
                    <input
                        v-model="params.height"
                        type="hidden"
                        :min="this.heightMin"
                        :max="this.heightMax" >
                    <span class="mr-1" style="font-weight: bold;font-size: 140%"> {{ height_formatted }} </span>
                    <div class="ml-4">
                      <button
                          v-if="$root.serviceSetting.height_increment.value == '1'"
                          class="btn btn-sm btn-gray mr-1 btn-fluc"
                          :data-min="this.heightMin"
                          :data-max="this.heightMax"
                          data-step="1"
                          @click="heightPlus">
                        <i class="fa fa-angle-up"></i> 1.0
                      </button>
                      <button
                          class="btn btn-gray mr-2 btn-fluc"
                          :data-min="this.heightMin"
                          :data-max="this.heightMax"
                          data-step="5"
                          @click="heightPlus">
                        <i class="fa fa-angle-double-up"></i> 5.0
                      </button>
                      <button
                          v-if="$root.serviceSetting.height_increment.value == '1'"
                          class="btn btn-sm btn-gray mr-1 btn-fluc"
                          :data-min="this.heightMin"
                          :data-max="this.heightMax"
                          data-step="1"
                          @click="heightMinus">
                        <i class="fa fa-angle-down"></i> 1.0 &nbsp;
                      </button>
                      <button
                          class="btn btn-gray mr-1 btn-fluc"
                          :data-min="this.heightMin"
                          :data-max="this.heightMax"
                          data-step="5"
                          @click="heightMinus">
                        <i class="fa fa-angle-double-down"></i> 5.0 &nbsp;
                      </button>
                    </div>
                  </div>
                </div>
                <!-- 足長 -->
                <div class="form-group">
                  <div class="form-control-static design1 mb-2">
                    <i class="fas fa-user"></i> {{ $t('足長') }}
                  </div>
                  <div class="form-inline">
                    <input
                        v-model="params.shoe"
                        type="hidden"
                        :min="this.shoeMin"
                        :max="this.shoeMax"
                        step="5">
                    <span class="mr-1" style="font-weight: bold;font-size: 140%"> {{ shoe_formatted }} </span>
                    <div class="ml-4">
                      <!--
                      <button
                          class="btn btn-sm btn-gray mr-1 btn-fluc"
                          :data-min="this.shoeMin"
                          :data-max="this.shoeMax"
                          data-step="1"
                          @click="shoePlus">
                        + 1.0
                      </button>
                      -->
                      <button
                          class="btn btn-gray mr-2 btn-fluc"
                          :data-min="this.shoeMin"
                          :data-max="this.shoeMax"
                          :data-step="this.shoeStep"
                          @click="shoePlus">
                        <i class="fa fa-angle-up"></i> {{(shoeStep / 10).toFixed(1)}}
                      </button>
                      <!--
                      <button
                          class="btn btn-sm btn-gray mr-1 btn-fluc"
                          :data-min="this.shoeMin"
                          :data-max="this.shoeMax"
                          data-step="1"
                          @click="shoeMinus">
                        - 1.0 &nbsp;
                      </button>
                      -->
                      <button
                          class="btn btn-gray mr-1 btn-fluc"
                          :data-min="this.shoeMin"
                          :data-max="this.shoeMax"
                          :data-step="this.shoeStep"
                          @click="shoeMinus">
                        <i class="fa fa-angle-down"></i> {{(shoeStep / 10).toFixed(1)}}
                      </button>
                    </div>
                  </div>
                </div>
                <!-- /足長 -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 items-wrapper">
          <div class="itemLoading" v-if="itemLoading === true">
            <div class="loading-message">
              <i class="fas fa-spinner fa-spin fa-3x"></i>
              読み込み中
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h4 class="border-dark border-bottom design1">
                {{ $t('レンタルするアイテムを選択してください') }}
              </h4>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <div class="form-box">
                <div class="btn-group-m1 d-flex flex-wrap">
                  <template v-for="i in this.selectOptions.item">
                    <button
                        v-if="selectOptions.items[i] && selectOptions.items[i].package && Object.keys(selectOptions.items[i]).length > 0"
                        class="btn"
                        :key="'item-'+i"
                        :class="{'btn-light': params.item != i, 'btn-info': params.item == i, 'btn-default': params.item !== '' && params.item != i}"
                        :value="i"
                        @click="updateItem">
                      {{
                        $t('message.item' + i.slice(0, 1).toUpperCase() +
                            i.slice(1))
                      }}
                    </button>
                  </template>
                  <button class="btn"
                          :class="{'btn-light': params.item != 'etc', 'btn-info': params.item == 'etc', 'btn-default': params.item !== '' && params.item != 'etc'}"
                          @click="updateItem" value="etc">{{$t('その他')}}</button>
                </div>
              </div>
            </div>

            <div class="col-12" v-if="params.item">
              <div class="form-box" v-if="params.item != 'etc'">
                <div v-if="this.selectOptions.items[this.params.item] && this.selectOptions.items[this.params.item].package"
                   class="col-12">
                <h6 class="design1 mt-4">
                  {{ $t('セット等をご希望の場合は選択してください') }}
                </h6>
                  <template v-if="this.alerts && this.alerts[this.params.itemCategory]">
                    <div class="text-danger bold">
                      {{$t(this.alerts[this.params.itemCategory])}}
                    </div>
                  </template>
                <div class="btn-group-m1 d-flex flex-wrap">
                  <button
                      v-for="i in this.selectOptions.items[this.params.item].package"
                      :key="'package-' + i.category_id"
                      class="btn"
                      :class="{'btn-light': params.itemCategory != i.category_id, 'btn-info': params.itemCategory == i.category_id }"
                      :value="i.category_id"
                      @click="updateItemCategory">
                    {{ $t(i.name) }}
                  </button>
                </div>
                <div
                    v-for="(e, index) in showInputError('item_category')"
                    :key="'error-item_category-' + index"
                    class="text-danger">
                  {{ $t(e.message) }}
                </div>
                <div v-if="reRendering">
                  <template v-for="ii in this.selectOptions.items[this.params.item].package">
                    <div
                        v-if="params.itemCategory == ii.category_id"
                        :key="'package-contains' + ii.category_id"
                        class="row">
                      <div class="col">
                        <ul
                            class="list-unstyled mt-3 mb-0"
                            style="border: 1px solid #CCC;padding:1rem;border-radius: 10px">
                          <li
                              v-for="iii in ii.contain"
                              :key="'contain-item' + iii.subcategory_id"
                              class="mt-1 d-flex justify-content-between flex-wrap">
                            <div :key="'i' + iii.subcategory_id">
                              <i v-if="(showStocks || showSoldOut) && getStockState(iii.subcategory_id).res === 0"
                                 class="fas fa-times text-danger"></i>
                              <i v-if="showStocks && getStockState(iii.subcategory_id).res === -1"
                                 class="fas fa-exclamation-triangle text-warning"></i>
                              <i class="fas fa-check-square text-success"></i> {{ $t(iii.name) }}
                              <template v-if="imageEnable && images(iii)">
                                <div v-for="(img, index) in images(iii)" :key="'img' + index" class="ml-2 package-item item-is-active d-inline-block" >
                                  <i class="fas fa-plus" v-if="index > 0"></i>
                                  <span class="item-pictogram"><img :src="'img/' + $root.serviceSetting.User.id + '/' +  img"/></span>
                                </div>
                              </template>
                            </div>
                            <div v-if="getStockState(iii.subcategory_id).res === 0"
                                 class="text-danger font-weight-bold">{{ $t(getStockState(iii.subcategory_id).message) }}
                            </div>
                            <div v-else-if="getStockState(iii.subcategory_id).message"
                                 class="text-warning font-weight-bold">{{ $t(getStockState(iii.subcategory_id).message) }}
                            </div>
                            <div v-if="getStockState(iii.subcategory_id).additionalMessage"
                                 class="text-danger additional-message">{{ $t(getStockState(iii.subcategory_id).additionalMessage) }}
                            </div>
                            <div style="font-size: 80%;color: #999" v-if="$root.$route.query.debug">
                              {{iii.subcategory_id}}:
                              {{getStockState(iii.subcategory_id).sizeKey}} /
                              {{getStockState(iii.subcategory_id).stockKey}} /
                              {{getStockState(iii.subcategory_id).rest}}
                            </div>
                          </li>
                        </ul>
                        <div class="text-right" v-if="$root.serviceSetting.visible_price_reserve.value === 'true'">
                          ￥ {{ prices[ii.category_id] | numberFormat }}
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              </div>
              <div class="form-box">
                <div v-if="params.item && params.item != 'etc' && this.selectOptions.items[params.item] && this.selectOptions.items[params.item].single">
                  <h4 class="border-dark border-bottom design1">
                    {{ $t('ご希望の単品その他アイテムを選択してください') }}
                  </h4>
                  <h5 class="ml-2 mt-4">
                    {{ $t('単品') }}
                  </h5>
                  <div v-for="i in this.selectOptions.items[params.item].single"
                       :key="'item-single-' + i.category_id"
                       class="mt-1 d-flex justify-content-between flex-wrap">
                    <div class="ml-2" :data-category-id="i.category_id">
                      <MyCheckbox
                          :image="i.image"
                          :imageEnable="$root.serviceSetting.enable_pictgram && $root.serviceSetting.enable_pictgram.value === 'true'"
                          :key="'item-single-check-' + i.category_id"
                          :name="i.category_id"
                          :status="itemStatus(i)"
                          :label="i.name"
                          :categoryId="i.category_id"
                          :price="i.price"
                          :itemCategory="params.itemCategory"
                          :isEtc="false"
                          :disabled="getStockState(i.category_id).res === 0"
                          @update-check="updateItemsCheck"/>
                        <div
                            v-if="itemStatus(i) === 'exists'"
                            class="" style="color: #ccc">{{$t(i.name)}}
                        </div>
                    </div>
                    <div
                        v-if="getStockState(i.category_id).res === 0 && itemStatus(i) !== 'hidden' && itemStatus(i) !== 'exists'"
                        class="text-danger font-weight-bold">{{ $t(getStockState(i.category_id).message) }}
                    </div>
                    <div
                        v-else-if="getStockState(i.category_id).message && itemStatus(i) !== 'hidden' && itemStatus(i) !== 'exists'"
                        class="text-warning font-weight-bold">{{ $t(getStockState(i.category_id).message) }}
                    </div>
                    <div v-if="getStockState(i.category_id).additionalMessage"
                         class="text-danger additional-message">{{ $t(getStockState(i.category_id).additionalMessage) }}
                    </div>
                    <div style="font-size: 80%;color: #999" v-if="$root.$route.query.debug && itemStatus(i) !== 'hidden' && itemStatus(i) !== 'exists'">
                      {{i.category_id}}:
                      {{getStockState(i.category_id).sizeKey}} /
                      {{getStockState(i.category_id).stockKey}} /
                      {{getStockState(i.category_id).rest}}
                    </div>
                  </div>
                </div>
                <!-- etc -->
                <div v-if="this.selectOptions.items.etc">
                  <h5 class="ml-2 mt-4">
                    {{ $t('その他') }}
                  </h5>
                  <div class="col">
                    <div class="btn-group-m1">
                      <div v-for="(etcItems, cat) in this.selectOptions.items.etc" :key="'itemC' + cat">
                        <div
                            v-for="i in etcItems"
                            :key="'item-etc-'+i.category_id"
                            class="mt-1 d-flex justify-content-between align-items-center flex-wrap">
                          <template v-if="!i.is_etc_only || params.item === 'etc'">
                            <div class="ml-2">
                              <template v-if="alerts[i.category_id] && params.rentalItems[i.category_id]">
                                <div class="text-danger bold">
                                {{alerts[i.category_id]}}
                                </div>
                              </template>
                              <MyCheckbox
                                  :key="'item-etc-check-'+i.category_id"
                                  :name="i.category_id"
                                  :label="i.name"
                                  :image="i.image"
                                  :imageEnable="$root.serviceSetting.enable_pictgram && $root.serviceSetting.enable_pictgram.value === 'true'"
                                  :itemCategory="params.itemCategory"
                                  :isEtc="true"
                                  :price="prices[i.category_id]"
                                  :categoryId="i.category_id"
                                  :status="itemStatus(i)"
                                  :disabled="(showStocks || showSoldOut) && getStockState(i.category_id).res === 0"
                                  @update-check="updateItemsCheck"/>
                            </div>
                            <div v-if="getStockState(i.category_id).res === 0 && itemStatus(i) !== 'hidden' && itemStatus(i) !== 'exists'"
                                 class="text-danger font-weight-bold">{{ $t(getStockState(i.category_id).message) }}
                            </div>
                            <div v-else-if="getStockState(i.category_id).message && itemStatus(i) !== 'hidden' && itemStatus(i) !== 'exists'"
                                 class="text-warning font-weight-bold">{{ $t(getStockState(i.category_id).message) }}
                            </div>
                            <div v-if="getStockState(i.category_id).additionalMessage"
                                 class="text-danger additional-message">{{ $t(getStockState(i.category_id).additionalMessage) }}
                            </div>
                            <div style="font-size: 80%;color: #999" v-if="$root.$route.query.debug && itemStatus(i) !== 'hidden' && itemStatus(i) !== 'exists'">
                              {{i.category_id}}:
                              {{getStockState(i.category_id).sizeKey}} /
                              {{getStockState(i.category_id).stockKey}} /
                              {{getStockState(i.category_id).rest}}
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="showStocks && params.item" class="row mt-4 text-danger font-weight-bold design2">
            {{ $t('※現時刻での在庫目安です。最終的な在庫状況は申込完了時にお知らせします') }}
          </div>
          <div class="row mt-4"
               v-if="!enableWGT && params.item && $root.serviceSetting && $root.serviceSetting.enable_require_weight.value === 'true' && (this.params.item === 'ski' || this.params.item === 'ssk')">
            <div class="col-12">
              {{$t('スキー板をレンタルされる方は、体重をご記入ください')}}
              <input class="form-control d-inline-block" type="number" max="999" min="0" style="width: 4em"
                     v-model="req['weight']" @change="refreshRequest"> kg
            </div>
          </div>

          <!-- weight & skiertype -->
          <div class="mt-4" v-if="enableWGT || enableSKR">
            <div class="col-12 form-box">
              <div class="form-group" v-if="enableWGT">
                <div class="form-control-static design1 mb-2">
                  <i class="fas fa-user"></i> {{ $t('体重') }}
                </div>
                <div class="btn-group-m1 d-flex flex-wrap">
                  <template v-if="this.selectOptions.WGT && Object.keys(this.selectOptions.WGT).length < 20">
                    <button
                        v-for="(wv, wk) in this.selectOptions.WGT"
                        class="flex-fill"
                        :key="'weight-'+wk"
                        :class="{btn: true, 'btn-light': params.weight != wk, 'btn-info': params.weight === wk}"
                        :value="wk"
                        @click="updateWeight">
                      {{ $t(wv) }}
                    </button>
                  </template>
                  <template v-else>
                    <select class="form-control" @change="updateWeightFromDropdown">
                      <option>
                        選択してください
                      </option>
                      <option
                            v-for="(wv, wk) in this.selectOptions.WGT"
                            class="dropdown-item btn-block"
                            :key="'weight-'+wk"
                            :class="{btn: true, 'btn-light': params.weight != wk, 'btn-info': params.weight === wk}"
                            :value="wk"
                            :selected="params.weight === wk" >
                          {{ $t(wv) }}
                      </option>
                    </select>
                  </template>
                </div>

                <div
                    v-for="(e, index) in showInputError('weight')"
                    :key="'error-item_category-' + index"
                    class="text-danger">
                  {{ $t(e.message) }}
                </div>
              </div>
              <!-- //weight -->
              <!-- skier_type -->
              <div class="form-group" v-if="enableSKR">
                <div class="form-control-static design1 mb-2">
                  <i class="fas fa-user"></i> {{ $t('スキーヤータイプ') }}
                </div>
                <div class="btn-group-m1 d-flex">
                  <button
                      v-for="(wv,wk) in this.selectOptions.SKR"
                      class="flex-fill"
                      :key="'skier_type-'+wk"
                      :class="{btn: true, 'btn-light': params.skier_type != wk, 'btn-info': params.skier_type === wk}"
                      :value="wk"
                      @click="updateSkierType">
                    {{ $t(wv) }}
                  </button>
                </div>
                <div
                    v-for="(e, index) in showInputError('skier_type')"
                    :key="'error-item_category-' + index"
                    class="text-danger">
                  {{ $t(e.message) }}
                </div>
              </div>
              <!-- //skier_type -->
            </div>
          </div>
          <!-- // wheight & skier_type -->

          <!-- スタンス -->
          <div class="mt-4"  v-if="enableStance && params.item === 'snb'">
            <div class="col-12 form-box">
              <div class="form-group">
                {{ $t('(スノボをレンタルされる方のみ、スタンスについてご回答ください)') }}
                <button :class="{btn: true, 'btn-light': params.stance != 'regular', 'btn-info': params.stance == 'regular'}"
                        @click="updateStance" value="regular">{{$t('レギュラー(スタンス)である')}}</button>
                <button :class="{btn: true, 'btn-light': params.stance != 'goofy', 'btn-info': params.stance == 'goofy'}"
                        @click="updateStance" value="goofy">{{$t('グーフィ(スタンス)である')}}</button>
                <button :class="{btn: true, 'btn-light': params.stance != 'unknown', 'btn-info': params.stance == 'unknown'}"
                        @click="updateStance" value="unknown">{{$t('分からない')}}</button>
              </div>
              <div>
                <h5>
                  {{$t('スタンスとは')}}
                </h5>
                {{$t('レギュラーは左足を前に、右足を後ろにする滑り方です。グーフィーはその逆で、利き足が左足の人に多いと言われています。')}}
              </div>
            </div>
          </div>
          <!-- /スタンス -->

          <div class="row mt-4" v-if="params.item">
            <div class="col-12"
                 v-if="$root.serviceSetting.enable_require_wear_size.value === 'true' || $root.serviceSetting.enable_require_board_size.value === 'true'">
              <h4 class="border-dark border-bottom">
                {{ $t('追加リクエスト') }}
              </h4>
              <div class="form-box">
                <div class="col-12">
                  <div class="d-flex" v-if="$root.serviceSetting.enable_require_wear_size.value === 'true'">
                    <div class="flex-fill p-2">
                      <button @click="setRequest('wear', '[ウェア大きめ]')"
                              class="btn btn-block"
                              :class="{'btn-info': requestExists('[ウェア大きめ]'), 'btn-light' : !requestExists('[ウェア大きめ]')}">
                        {{ $t('ウェア大きめ')}}
                      </button>
                    </div>
                    <div class="flex-fill p-2">
                      <button class="btn btn-block ml-1" @click="setRequest('wear', '[ウェア小さめ]')"
                              :class="{'btn-info': requestExists('[ウェア小さめ]'), 'btn-light' : !requestExists('[ウェア小さめ]')}">
                        {{ $t('ウェア小さめ')}}
                      </button>
                    </div>
                  </div>
                  <div class="d-flex"
                       v-if="this.params.item == 'snb' && $root.serviceSetting.enable_require_board_size.value === 'true'">
                    <div class="flex-fill p-2">
                      <button class="btn btn-block" @click="setRequest('snb', '[ボード大きめ]')"
                              :class="{'btn-info': requestExists('[ボード大きめ]') , 'btn-light' : !requestExists('[ボード大きめ]')}">
                        {{ $t('ボード大きめ') }}
                      </button>
                    </div>
                    <div class="flex-fill p-2">
                      <button class="btn btn-block ml-1" @click="setRequest('snb', '[ボード小さめ]')"
                              :class="{'btn-info': requestExists('[ボード小さめ]'), 'btn-light' : !requestExists('[ボード小さめ]')}">
                        {{ $t('ボード小さめ') }}
                      </button>
                    </div>
                  </div>
                  <div class="d-flex"
                       v-if="this.params.item === 'ski' && $root.serviceSetting.enable_require_board_size.value === 'true'">
                    <div class="flex-fill p-2">
                      <button class="btn btn-block" @click="setRequest('ski', '[スキー大きめ]')"
                              :class="{'btn-info': requestExists('[スキー大きめ]') , 'btn-light' : !requestExists('[スキー大きめ]')}">
                        {{ $t('スキー大きめ') }}
                      </button>
                    </div>
                    <div class="flex-fill p-2">
                      <button class="btn btn-block ml-1" @click="setRequest('ski', '[スキー小さめ]')"
                              :class="{'btn-info': requestExists('[スキー小さめ]'), 'btn-light' : !requestExists('[スキー小さめ]')}">
                        {{ $t('スキー小さめ') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 mt-4" v-if="$root.serviceSetting.enable_require_textarea.value === 'true'">
              <h4 class="border-dark border-bottom">
                {{ $t('備考欄') }}
              </h4>
              <div class="form-box">
                <textarea class="form-control" v-model="req['text']" @change="refreshRequest"></textarea>
              </div>
            </div>
            <div class="col-12 mt-4">
              <div class="d-flex">
                <button
                    type="button"
                    class="btn btn-lg btn-block btn-3d btn-primary btn-h-6 design4 flex-fill"
                    :class="{'Rental_cv3': mode === 'add', 'next-btn-disabled': hasOutOfStock}"
                    :disabled="hasOutOfStock"
                    @click="correctMember">
                  <span v-if="mode === 'add'">{{ $t('カートに入れる') }}</span>
                  <span v-if="mode === 'update'">{{ $t('カート内容を更新') }}</span>
                  <span v-if="$root.serviceSetting.visible_price_reserve.value === 'true'">
                    <br> ￥ {{ totalPrice | numberFormat }}
                  </span>
                </button>
                &nbsp;
                <button
                    v-if="mode === 'update'"
                    type="button"
                    class="btn btn-warning mr-4 btn-h-6 btn-3d text-white design4 flex-fill"
                    @click="backToCart">
                  <span>{{ $t('message.backToCart') }}</span>
                </button>
                <button
                    v-if="mode === 'add' && currentCount > 0"
                    type="button"
                    class="btn btn-warning mr-4 btn-3d btn-h-6 text-white design4 flex-fill"
                    @click="backToCart">
                  <span>{{ $t('message.backToCart') }}</span>
                </button>
              </div>
            </div>
          </div>

        </div>
        <div class="col-12">
          <div class="row mt-4">
            <div class="col text-right"/>
          </div>
        </div>
      </div>
      <vue-touch-keyboard
          v-if="visible"
          id="keyboard"
          :layout="layout"
          :cancel="hide"
          :accept="accept"
          :input="input"
          :next="next"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueTouchKeyboard from 'vue-touch-keyboard'
import MyCheckbox from './MyCheckBox'
import style from 'vue-touch-keyboard/dist/vue-touch-keyboard.css'
import axios from 'axios'
import Underscore from 'vue-underscore'

axios.defaults.headers.post['Content-type'] = 'application/x-www-form-urlencoded'
Vue.use(VueTouchKeyboard)
Vue.use(style)
Vue.use(MyCheckbox)
Vue.use(Underscore)

function initialState () {
  return {
    isReady: false,
    visible: false,
    errors: [],
    input: null,
    options: {
      useKbEvents: false,
      preventClickEvent: true
    },
    itemLoading: true,
    hasOutOfStock: false,
    params: {
      first_name: '',
      last_name: '',
      sex: 'M',
      age: '21',
      height: '160',
      weight: '', // 体重コード
      skier_type: '', // スキーヤータイプコード
      shoe: '250',
      stance: '',
      request: '',
      item: '',
      rentalItems: {},
      itemInactive: {},
      itemCategory: '',
      itemCategoryName: '',
      itemCategoryPrice: 0,
      isRepresentative: false,
      req: {
        wear: '',
        ski: '',
        snb: '',
        ssk: '',
        weight: '',
        text: ''
      }
    },
    orgParams: {},
    req: {
      wear: '',
      ski: '',
      snb: '',
      ssk: '',
      weight: '',
      text: ''
    },
    systemOptions: [],
    prices: [],
    names: [],
    alerts: [],
    statusOfItem: [],
    sizes: [],
    boards: [],
    setItems: [],
    selectOptions: {
      items: {
        'etc': {
          'package': {},
          'single': {}
        }
      },
      ages: [
        '00', '06', '09', '12', '18', '19', '20', '21', '30', '40', '50', '60', '70'
      ],
      sex: [
        'M', 'F'
      ],
      stance: [
        'regular', 'goofy', 'unknown'
      ],
      item: [
        'snb', 'ski', 'ssk'
      ],
      itemOptions: {
        'main_snb_pac': {
          'main_snb_board': 1,
          'main_snb_boot': 1,
          'main_snb_wear': 1,
          'main_snb_ticket': 1,
          'main_snb_accessory': 1
        },
        'main_snb_set': {
          'main_snb_board': 1,
          'main_snb_boot': 1,
          'main_snb_wear': 1
        },
        'main_snb_single': {
          'main_snb_board': 0,
          'main_snb_boot': 0,
          'main_snb_wear': 0
        },
        'main_ski_pac': {
          'main_ski_board': 1,
          'main_ski_boot': 1,
          'main_ski_wear': 1,
          'main_ski_pole': 1,
          'main_ski_ticket': 1,
          'main_ski_accessory': 1
        },
        'main_ski_set': {
          'main_ski_board': 1,
          'main_ski_boot': 1,
          'main_ski_wear': 1,
          'main_ski_pole': 1
        },
        'main_ski_single': {
          'main_ski_board': 0,
          'main_ski_boot': 0,
          'main_ski_wear': 0,
          'main_ski_pole': 0
        },
        'main_ssk_pac': {
          'main_ssk_board': 1,
          'main_ssk_boot': 1,
          'main_ssk_wear': 1,
          'main_ssk_ticket': 1,
          'main_ssk_accessory': 1
        },
        'main_ssk_set': {
          'main_ssk_board': 1,
          'main_ssk_boot': 1,
          'main_ssk_wear': 1
        },
        'main_ssk_single': {
          'main_ssk_board': 0,
          'main_ssk_boot': 0,
          'main_ssk_wear': 0
        }
      },
      itemSnb: [
        'main_snb_pac', 'main_snb_set', 'main_snb_single'
      ],
      itemSnbEtc: [
        'etc_helmet', 'etc_boot', 'etc_wear'
      ],
      itemSki: [
        'main_ski_pac', 'main_ski_set', 'main_ski_single'
      ],
      itemSkiEtc: [
        'etc_helmet', 'etc_boot', 'etc_wear'
      ],
      itemSsk: [
        'main_ssk_pac', 'main_ssk_set', 'main_ssk_single'
      ],
      itemSskEtc: [
        'etc_helmet', 'etc_boot', 'etc_wear'
      ],
      weight: [],
      skier_type: []
    },
    reRendering: 0,
    recSizes: {
      board_size: 155,
      ski_size: 160,
      skipole_size: 120,
      shoe_size: 26.5,
      shoe_size_board: 26.5,
      shoe_size_ski: 26.5,
      wear_size: 170,
      met_size: 170,
      rubber_size: 40
    },
    stockList: {},
    shareSizesList: {},
    enableName: true,
    requireEntryName: true,
    showStocks: true,
    showSoldout: false,
    membersCount: 1,
    representative: '',
    codesValue: {},
    heightMin: '',
    heightMax: '',
    shoeMin: '',
    shoeMax: '',
    totalPrice: 0,
    shoeStep: 5
  }
}
export default {
  name: 'Member',
  components: { MyCheckbox },
  props: ['mode', 'current', 'currentCount'],
  data () {
    return initialState()
  },
  computed: {
    imageEnable () {
      return this.$root.serviceSetting.enable_pictgram && this.$root.serviceSetting.enable_pictgram.value === 'true'
    },
    showErrors () {
      if (this.errors.length > 0) {
        return this.$t('入力内容を確認してください')
      }
      return null
    },
    height_formatted () {
      let val = parseInt(this.params.height)
      if (val > 0) {
        return val + ' cm'
      }
      return null
    },
    shoe_formatted () {
      let val = parseInt(this.params.shoe)
      if (val > 0) {
        return (val / 10).toFixed(1) + ' cm'
      }
      return null
    },
    isRentCar () {
      var isRentCar = false
      if (this.$root.$route.query.int && this.$root.$route.query.int.substr(-1) === 'J') {
        isRentCar = true
      }
      return isRentCar
    },
    enableWGT () {
      return this.$root.$store.state.selectOptions['WGT'] !== undefined && Object.keys(this.$root.$store.state.selectOptions['WGT']).length > 0 &&
          (this.params.item === 'ski' || this.params.item === 'ssk')
    },
    enableSKR () {
      return this.$root.$store.state.selectOptions['SKR'] !== undefined && Object.keys(this.$root.$store.state.selectOptions['SKR']).length > 0 &&
          (this.params.item === 'ski' || this.params.item === 'ssk')
    },
    enableStance () {
      // console.log('enableStance', this.$root.serviceSetting?.enable_stance?.value)
      return this.$root.serviceSetting?.enable_stance?.value === 'true'
    }
  },
  watch: {
    mode: {
      immediate: true,
      handler () {
        if (this.mode === 'add') {
          this.reset()
        }
      }
    },
    current: {
      immediate: true,
      handler () {
        if (this.current) {
          this.params = this.current
        }
      }
    }
  },
  filters: {
    numberFormat (value) {
      let isString = (typeof value === 'string' || value instanceof String)
      if (value === undefined) {
        return null
      }
      if (isString) {
        return value
      }
      if (isNaN(value)) {
        return 0
      }
      let formatter = new Intl.NumberFormat('ja-JP')
      return formatter.format(value)
    }
  },
  mounted () {
    // console.log('Member::mounted')
    // console.log(this.params)
    this.mountedAction()
  },
  methods: {
    async mountedAction () {
      console.log('Member::mountedAction')
      // orgParamsにparamsのディープコピーをとっておく
      this.orgParams = JSON.parse(JSON.stringify(this.params))

      this.getCodes()
      this.setValues()
      await this.getStockList(true)
      await this.getItems(false)
      if (this.mode !== 'add') {
        if (this.params.req) {
          this.req = this.params.req
        }
      }
      if (this.$root.serviceSetting.shoe_increment.value === '0.5') {
        this.shoeStep = 5
      }
      if (this.$root.serviceSetting.shoe_increment.value === '1.0') {
        this.shoeStep = 10
      }
      this.isReady = true
    },
    getCodes () {
      this.$emit('get-codes')
    },
    images (item) {
      if (item.image) {
        return item.image.split(',')
      }
      return item.image
    },
    async getItems (runReset) {
      this.itemLoading = true
      let ui = this.$root.$route.query.ui ? this.$root.$route.query.ui : ''
      let introduceType = this.$root.$route.query.int ? this.$root.$route.query.int : ''
      let dev = this.$root.$route.query.dev
      let url = this.$root.baseURL +
        'items.json?ui=' + ui +
        '&int=' + introduceType +
        '&age=' + this.params.age +
        '&height=' + this.params.height +
        '&weight=' + this.params.weight +
        '&skier_type=' + this.params.skier_type +
        '&shoe=' + this.params.shoe +
        '&sex=' + this.params.sex +
        '&term=' + this.$root.$store.state.reserve_term +
        '&start=' + this.$root.$store.state.rentalDate +
        '&dev=' + dev
      let _self = this
      await axios.get(url, {
        params: this.data
      }).then(response => {
        if (runReset === true && !this.$_.isEqual(this.names, response.data.names)) {
          _self.itemReset()
        }
        _self.systemOptions = response.data.systemOptions
        _self.prices = response.data.prices
        _self.alerts = response.data.alerts
        _self.names = response.data.names
        _self.boards = response.data.boards
        _self.setItems = response.data.setItems

        _self.params.sizes = response.data.sizes
        // this.selectOptions.items = response.data.items
        if (_self.selectOptions.items && Object.keys(_self.selectOptions.items).length > 0) {
          // console.log('keys', Object.keys(_self.selectOptions.items))
          // console.log('response keys ssk', response.data.items['ssk'])
          Object.keys(_self.selectOptions.items).forEach(function (key) {
            // console.log('key:', key)
            if (!response.data.items[key]) {
              delete _self.selectOptions.items[key]
            }
          })
        }
        let tmp = response.data.items
        _self.$_.each(tmp, function (v, itemGroupName) {
          _self.selectOptions.items[itemGroupName] = {}
          _self.$_.each(v, function (vv, itemTypeName) {
            _self.selectOptions.items[itemGroupName][itemTypeName] = {}
            _self.$_.each(vv, function (vvv, categoryId) {
              _self.selectOptions.items[itemGroupName][itemTypeName][vvv.sequence] = vvv
              // console.log('selectOptions.items', itemGroupName, itemTypeName, vvv.sequence)
            })
          })
        })
        var newItems = []
        const obj = _self.selectOptions.items.etc.single
        Object.keys(obj).forEach(function (key) {
          // if (obj[key].name !== '大人ウェア単品' && obj[key].name !== '小人ウェア単品') {
          newItems.push(obj[key])
          // }
        })
        _self.selectOptions.items.etc.single = newItems
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        _self.itemLoading = false
        _self.refreshTotalPrice()
      })
    },
    itemReset () {
      this.params.itemInactive = {}
      this.params.rentalItems = {}
      this.params.itemCategory = ''
      this.params.itemCategoryName = ''
      this.params.itemCategoryPrice = 0
    },
    reset () {
      let p = initialState()
      this.$set(this.params, p.params)
    },
    setMember () {
      this.member = this.props.member
    },
    correctMember () {
      if (this.checkForm()) {
        let params = this.params
        params.req = this.req
        this.$emit('correct', params)
        this.reset()
      } else {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      }
    },
    backToCart () {
      // this.$emit('backToCart')
      // 編集をresetする
      let orgParams = this.orgParams
      let params = this.params
      console.log('backToCart', params)
      // orgParamsとparamsを比較して違いがある部分はorgParamsの値にする
      params = this.mergeOfDifferences(params, orgParams)
      this.$emit('correct', params)
      this.$emit('back-to-cart')
      this.reset()
    },
    showInputError (field) {
      let res = this.$_.where(this.errors, { field: field })
      if (res) {
        return res
      }
    },
    addError (field, message) {
      this.errors.push({
        field: field,
        message: message
      })
    },
    // aとbを比較して、違いがあればbで上書きする
    mergeOfDifferences (a, b) {
      let result = { ...a } // Aを基に新しいオブジェクトを作成
      Object.keys(b).forEach(key => {
        if (a[key] !== b[key]) {
          console.log('merge key:' + key, a[key], b[key])
          result[key] = b[key] // Bの値を採用
        }
      })
      return result
    },
    checkForm (e) {
      this.errors = []
      if (this.membersCount === 1 || this.isRepresentative) { // 代表者か2人め以降か
        this.params.isRepresentative = true
        this.checkNameForm() // フォームチェック
      } else {
        if (this.enableName) { // 氏名入力欄表示
          this.checkNameForm() // フォームチェック
        } else { // 代表者の姓名カナ+「(N人め)」等をDBに登録する
          this.params.last_name = this.representative
          this.params.first_name = this.membersCount + '人め'
        }
      }
      let field = 'item_category'
      if (this.params.itemCategory === '' || this.params.itemCategory === null || this.params.itemCategory === undefined) {
        if (Object.keys(this.params.rentalItems).length > 0) {
          // console.log(this.params.rentalItems)
        } else {
          // console.log(Object.keys(this.params.rentalItems).length)
          this.addError(field, 'アイテムを選択してください')
        }
      }
      if (this.enableWGT) {
        // console.log('weight', this.params.weight)
        if (this.params.weight === '' || this.params.weight === null || this.params.weight === undefined) {
          this.addError('weight', '体重を選択してください')
        }
      }
      if (this.enableSKR) {
        if (this.params.skier_type === '' || this.params.skier_type === null || this.params.skier_type === undefined) {
          this.addError('skier_type', 'スキーヤータイプを選択してください')
        }
      }

      let hasGradeupBoots = false
      let hasGradeupBoard = false
      let hasGradeupBinding = false
      let hasGradeupSet = false
      let hasGradeupStock = false
      let hasBoots = false
      let hasBoard = false
      let hasBinding = false
      let hasSet = false
      let hasStock = false

      // console.log(this.params.itemCategory)
      hasSet = this.params.itemCategory !== ''
      // Object.keys(this.params.rentalItems).forEach(categoryId => {
      this.$_.each(this.params.rentalItems, item => {
        let name = item.name
        let categoryId = item.category_id
        if (name.match(/グレードアップ|アップグレード/)) {
          if (name.match(/靴/)) {
            hasGradeupBoots = true
          }
          if (name.match(/セット|フルパック/)) {
            hasGradeupSet = true
          }
          if (name.match(/板/)) {
            hasGradeupBoard = true
          }
          if (categoryId !== '135' && name.match(/ビンディング|バインディング|金具/)) {
            hasGradeupBinding = true
          }
          if (name.match(/ストック/)) {
            hasGradeupStock = true
          }
        } else {
          if (name.match(/靴/)) {
            hasBoots = true
          }
          if (name.match(/板/)) {
            hasBoard = true
          }
          if (name.match(/ビンディング|バインディング|金具/)) {
            hasBinding = true
          }
          if (name.match(/ストック/)) {
            hasStock = true
          }
        }
        // console.log('itemCategory', this.params.itemCategory)
      })
      if ((hasGradeupSet && !hasSet) || (hasGradeupBoots && !hasBoots) || (hasGradeupBoard && !hasBoard) || (hasGradeupBinding && !hasBinding) || (hasGradeupStock && !hasStock)) {
        this.addError('item_category', 'アップグレードする対象となるセット、板、靴、ビンディング、ストックをレンタルする場合のみアップグレード可能です')
      }

      if (this.errors.length > 0) {
        return false
      }
      return true
    },
    checkNameForm () {
      let required = ['first_name', 'last_name']
      if (this.$store.state.isCRMMember) {
        required = ['last_name']
      }
      required.forEach((field, i) => {
        let checkValue = this.params[field].trim()
        if (checkValue === '' || this.params[field] === null || this.params[field] === undefined) {
          this.addError(field, 'message.errors.required')
        }
      })
    },
    plusVal (val, min, max, step) {
      min = Number(min)
      max = Number(max)
      step = Number(step)

      let newVal = Number(val) + step
      if (newVal <= max) {
        return newVal
      }
      if (newVal > max) {
        return max
      }
      return val
    },
    minusVal (val, min, max, step) {
      min = Number(min)
      max = Number(max)
      step = Number(step)

      let newVal = Number(val) - step
      if (newVal >= min) {
        return newVal
      }
      if (newVal < min) {
        return min
      }
      return val
    },
    heightPlus (e) {
      let max = e.currentTarget.dataset.max
      let min = e.currentTarget.dataset.min
      let step = e.currentTarget.dataset.step
      // this.params.height = this.plusVal(this.params.height, min, max, step)
      let val = this.plusVal(this.params.height, min, max, step)
      this.params.height = val < 100 ? '0' + val : val
      this.getRecSizes()
    },
    heightMinus (e) {
      let max = e.currentTarget.dataset.max
      let min = e.currentTarget.dataset.min
      let step = e.currentTarget.dataset.step
      // this.params.height = this.minusVal(this.params.height, min, max, step)
      let val = this.minusVal(this.params.height, min, max, step)
      this.params.height = val < 100 ? '0' + val : val
      this.getRecSizes()
    },
    shoePlus (e) {
      let max = e.currentTarget.dataset.max
      let min = e.currentTarget.dataset.min
      let step = e.currentTarget.dataset.step
      this.params.shoe = this.plusVal(this.params.shoe, min, max, step)
      this.getRecSizes()
    },
    shoeMinus (e) {
      let max = e.currentTarget.dataset.max
      let min = e.currentTarget.dataset.min
      let step = e.currentTarget.dataset.step
      this.params.shoe = this.minusVal(this.params.shoe, min, max, step)
      this.getRecSizes()
    },
    updateSex (e) {
      this.params.sex = e.target.value
      this.getRecSizes()
      this.getItems(true)
    },
    updateSkierType (e) {
      this.params.skier_type = e.target.value
      // this.getRecSizes()
      // this.getItems(true)
    },
    updateWeightFromDropdown (e) {
      // console.log('weight', e.target.value)
      this.params.weight = e.target.value
      // this.getRecSizes()
      // this.getItems(true)
    },
    updateWeight (e) {
      this.params.weight = e.target.value
      // this.getRecSizes()
      // this.getItems(true)
    },
    updateAge (e) {
      this.params.age = e.target.value
      this.getRecSizes()
      this.getItems(true)
    },
    updateStance (e) {
      // console.log('updateStance')
      this.params.stance = e.target.value
      // this.getRecSizes()
      // this.getItems(true)
      this.refreshRequest()
    },
    updateItem (e) {
      if (this.params.item === e.target.value) {
      } else {
        this.params.item = e.target.value
        this.params.rentalItems = {}
        this.params.itemInactive = {}
        this.params.itemCategory = ''
        this.params.itemCategoryName = ''
        this.params.itemCategoryPrice = ''
        this.req['ski'] = ''
        this.req['snb'] = ''
        this.req['ssk'] = ''
        this.req['wear'] = ''
        this.req['text'] = ''
        if (this.params.item !== 'ski' && this.params.item !== 'ssk') {
          this.req['weight'] = ''
          this.params.weight = ''
          this.params.skier_type = ''
        }
        this.refreshRequest()
        this.refreshTotalPrice()
      }
      // console.log('updateItem', e.target.value, this.params)
    },
    checkSetItems () {
      let item = this.params.item
      let categoryId = this.params.itemCategory
      if (item === '') {
        return
      }
      let children = null
      this.hasOutOfStock = false
      let _self = this
      this.$_.each(this.selectOptions.items[item]?.package, function (a) {
        if (a.category_id === categoryId && a.children) {
          children = a.children
          if (children) {
            children.forEach(childId => {
              // セットに含まれているアイテムの状態を確認
              let stockStatus = _self.getStockState(childId)
              if (stockStatus.res !== 1) {
                console.log('outOfStock:', stockStatus, childId)
                _self.hasOutOfStock = true
              }
            })
          }
        }
      })
    },
    _updateItemCat (val, toggle) {
      if (this.params.itemCategory === val && toggle === true) {
        // 解除
        this.params.itemCategory = ''
        this.params.rentalItems = {}
        this.params.itemInactive = {}
        this.params.itemCategoryName = ''
        this.params.itemCategoryPrice = ''
      } else {
        // 切り替え
        this.params.itemCategory = val
        this.params.itemCategoryName = this.names[val]
        this.params.itemCategoryPrice = this.prices[val]
        this.params.rentalItems = {}
        this.params.itemInactive = {}
        let children = null

        this.$_.each(this.selectOptions.items[this.params.item].package, function (a) {
          if (a.category_id === val && a.children) {
            children = a.children
          }
        })
        if (children) {
          children.forEach(childId => {
            // セットに含まれているアイテムは単品から削除する
            // 選択肢から外す
            this.params.itemInactive[childId] = true
            // 単品から削除
            if (this.$_.has(this.params.rentalItems, childId)) {
              delete this.params.rentalItems[childId]
            }
          })
        }
        // console.log('itemInactive', this.params.itemInactive)
      }
      this.checkSetItems()
      // console.log('_updateItemCat', val, toggle, this.params)
      this.refreshTotalPrice()
    },
    updateItemCategory (e) {
      // console.log('updateItemCategory')
      let val = e.target.value
      this._updateItemCat(val, true)
    },
    updateItemEtc (e) {
      // console.log('updateItemEtc')
      this.params.itemEtc = e.target.value
      this.refreshTotalPrice()
    },
    accept (text) {
      // console.log('accept')
      this.hide()
    },
    show (e) {
      if (this.$root.$route.query.dev !== 'tab2') {
        return true
      }
      let layout = e.target.dataset.layout
      e.target.readOnly = true
      this.input = e.target
      if (this.keyboardLayoutSet[layout]) {
        this.layout = this.keyboardLayoutSet[layout]
      }
      if (!this.visible) {
        this.visible = true
      }
    },
    itemStatus (item) {
      let result = ''

      // console.log(item)
      if (item.name.match(/グレードアップ|アップグレード/)) {
        if (this.params.itemCategory === '' && item.name.match(/セット/)) {
          // セットなど未選択の場合、セット用GUは非表示
          return 'hidden'
        } else if (this.params.itemCategory !== '' && !item.name.match(/セット/)) {
          // 選択済みの場合
          return 'hidden'
        }
      }

      if (item.name.match(/ウェア/)) {
        if (this.params.itemCategoryName.match(/フルパック/)) {
          return 'hidden'
        }
      }
      if (this.$_.has(this.params.itemInactive, item.category_id)) {
        return 'exists'
      }
      this.$_.each(this.params.rentalItems, function (i) {
        if (i.item === item.category_id) {
          result = 'checked'
        }
      })
      // if (this.$_.has(this.params.rentalItems, item.category_id)) {
      //   result = 'checked'
      // }
      return result
    },
    updateItemsCheck (categoryId) {
      // console.log('updateItemsCheck', categoryId)
      let data = {
        item: categoryId,
        name: this.names[categoryId],
        price: this.prices[categoryId],
        num: 1
      }
      let exists = this.$_.has(this.params.rentalItems, categoryId)
      // console.log('exists', exists)

      if (!exists) {
        this.params.rentalItems[categoryId] = data
      } else {
        delete this.params.rentalItems[categoryId]
      }
      // console.log(this.params.rentalItems)
      this.$forceUpdate()
      this.convertSetItems()
      this.refreshTotalPrice()
    },
    convertSetItems () {
      let setItems = this.setItems[this.params.item]
      let _self = this
      let point = 0 // 合致する点数
      let item = null // 採用する商品
      let rentalItemsKey = Object.keys(this.params.rentalItems)
      let itemCategory = this.params.itemCategory
      _self.$_.each(setItems, function (setItemIds, setId) { // v アイテム配列 / setId セットのcategoryId
        setId = String(setId)
        let items = []
        let matches = []
        if (itemCategory) {
          rentalItemsKey += Object.values(setItems[itemCategory])
        }
        _self.$_.each(setItemIds, function (itemId) { // セットの配列の内容がレンタルアイテムに入っているか
          itemId = String(itemId)
          items.push(itemId)
          if (rentalItemsKey.includes(itemId)) {
            matches.push(itemId)
          }
        })
        if (items.length === matches.length) {
          if (items.length > point) {
            item = setId
            point = items.length
          }
        }
      })
      if (item && item !== itemCategory) {
        _self.$_.each(_self.setItems[_self.params.item][item], function (c) {
          // delete _self.params.rentalItems[c]
        })
        _self._updateItemCat(item, false)
      }
    },
    changeCheckbox (e) {
      console.log(e.target.name)
    },
    hasItem (item) {
      if (this.$_.has(this.params.rentalItems, item)) {
        return true
      }
      return false
    },
    hide () {
      this.visible = false
    },
    next () {
      let inputs = document.querySelectorAll('input')
      let found = false
      if (inputs) {
        [].forEach.call(inputs, (item, i) => {
          if (!found && item === this.input && i < inputs.length - 1) {
            found = true
            this.$nextTick(() => {
              inputs[i + 1].focus()
            })
          }
        })
        if (!found) {
          this.input.blur()
          this.hide()
        }
      }
    },
    async getStockList (init = false) {
      let _self = this
      const str = this.$root.$store.state.rentalDate
      const start = str.replace(/\//g, '-')
      const ui = this.$root.$route.query.ui
      let url = this.$root.baseURL + 'getStockInfo/' + ui + '/' + start + '/' + this.$root.$store.state.reserve_term
      await axios.get(url).then(response => {
        this.formObject(response.data).then(value => {
          if (init) {
            _self.getShareSizes().then(value => {
              _self.getRecSizes()
            })
          } else {
            _self.getRecSizes()
          }
        })
      }).catch(error => {
        console.log(error)
      })
    },
    async formObject (data) {
      let _self = this
      // console.log('stockList', _self.stockList)
      Object.keys(data).forEach(function (key) {
        let stock = data[key]
        _self.stockList[key] = stock
      })
    },
    getStockState (id) {
      let sizes = this.recSizes
      let sizeKey
      let key = 0.0
      let idStr = String(id)
      // todo アイテム別欠品メッセージ準備中
      let soldoutMessages = {
        'board_size': '身長を変更すると在庫が残っている場合があります。',
        'ski_size': '身長を変更すると在庫が残っている場合があります。',
        'shoe_size_ski': '足長を変更すると在庫が残っている場合があります。',
        'shoe_size_board': '足長を変更すると在庫が残っている場合があります。',
        'short_ski_size': '身長を変更すると在庫が残っている場合があります。',
        'wear_size': '身長を変更すると在庫が残っている場合があります。',
        'rubber_size': '足長を変更すると在庫が残っている場合があります。'
      }

      // ToDo: IDで仕分けはできないのでitem.tagsから仕分けるか

      switch (idStr) {
        case '2': // 大人スノボ板
        case '13': // 小人スノボ板
        case '145': // 小人スノボ板
        case '177': // 小人スノボ板
        case '242': // pia
        case '265': // pia
        case '351': // washi
        case '372': // washi
          sizeKey = 'board_size'
          break
        case '5': // 大人スキー板
        case '16': // 小人スキー板
        case '154': // 小人スキー板
        case '184': // 小人スキー板
        case '248': // pia
        case '271': // pia
        case '356': // washi
        case '377': // washi
          sizeKey = 'ski_size'
          break
        case '7': // 大人スキーストック
        case '18': // 小人スキーストック
        case '156': // 小人スキーストック
        case '186': // 小人スキーストック
        case '251': // pia
        case '274': // pia
        case '359': // washi
        case '380': // washi
          sizeKey = 'skipole_size'
          break
        // case '3': // 大人スノボ靴
        // case '6': // 大人スキー靴
        // case '14': // 小人スノボ靴
        // case '17': // 小人スキー靴
        //   key = sizes['shoe_size'].toFixed(1)
        //   break
        case '3': // 大人スノボ靴
        case '14': // 小人スノボ靴
        case '146': // 大人スノボ靴
        case '178': // 小人スノボ靴
        case '243': // pia
        case '266': // pia
        case '352': // washi
        case '373': // washi
          sizeKey = 'shoe_size_board'
          break
        case '6': // 大人スキー靴
        case '17': // 小人スキー靴
        case '155': // 大人スキー靴
        case '185': // 小人スキー靴
        case '250': // pia
        case '273': // pia
        case '358': // washi
        case '379': // washi
          sizeKey = 'shoe_size_ski'
          break
        case '9': // 大人ショートスキー板
        case '35': // 小人ショートスキー板
        case '163': // 大人ショートスキー板
        case '191': // 小人ショートスキー板
        case '249': // pia
        case '272': // pia
        case '357': // washi
          sizeKey = 'shortski_size'
          // key = '100.0'
          break
        case '10': // 大人ウェア上下
        case '21': // 小人ウェア上下
        case '19': // 小人ウェア上下
        case '23': // 小人ウェア上下
        case '165': // 大人ウェア上下
        case '166': // 大人ウェア上下
        case '193': // 小人ウェア上下
        case '194': // 小人ウェア上下
        case '256': // 小人ウェア上下
        case '257': // 小人ウェア上下
        case '258': // 小人ウェア上下
        case '279': // 小人ウェア上下
        case '280': // 小人ウェア上下
        case '292': // 小人ウェア上下
        case '362': // 小人ウェア上下
        case '363': // 小人ウェア上下
        case '383': // 小人ウェア上下
        case '384': // 小人ウェア上下
          sizeKey = 'wear_size'
          break
        case '11': // 大人ヘルメット
        case '20': // 大人ヘルメット
        case '167': // 大人ヘルメット
        case '195': // 大人ヘルメット
        case '262': // 大人ヘルメット
        case '285': // 大人ヘルメット
        case '367': // 大人ヘルメット
        case '388': // 大人ヘルメット
          sizeKey = 'met_size'
          break
        case '33': // 小人長靴
        case '66': // 大人長靴
        case '368': // 大人長靴
        case '389': // 大人長靴
          sizeKey = 'rubber_size'
          break
        default: // 20: 小人ヘルメット, 21: 大人ウェア単品, 23: 小人ウェア単品, 25: 土日祝リフト１日券(大人)食事券, 26: 平日リフト１日券(大人), 27: ファミリーリフト１日券, 28: 小人リフト１日券, 29: レンタルシーズン券 (スタッフ), 30: レンタル１日券 (スタッフ), 36: 大人小物セット, 37: 小人小物セット, 44: 大人共通リフト１日券, 45: 小人共通リフト１日券
          key = '0.0'
          break
      }

      if (sizes[sizeKey]) {
        key = sizes[sizeKey].toFixed(1)
      }
      let result = {
        res: 1, // 0: 欠品中, 1: 在庫あり, -1: 売り止め
        message: '',
        additionalMessage: '',
        stockKey: '',
        sizeKey: '',
        rest: 9999
      }
      if (this.stockList && this.stockList[id]) {
        let strKey = String(key)
        if (strKey === '0') {
          strKey = '0.0'
        }
        if (sizeKey) {
          result.sizeKey = sizeKey
        }
        if (strKey) {
          result.stockKey = strKey
        }
        // console.log('id:' + id + ' strKey:' + strKey + ' stockList:' + this.stockList[id][strKey])
        result.stockKey = strKey
        let stock = strKey && strKey.length > 0 && this.stockList[id] && this.stockList[id][strKey] ? this.stockList[id][strKey] : null

        if (stock === null) {
          // category_idを読みかえして存在するかチェック
          if (this.shareSizesList[id]) {
            let convertedId = this.shareSizesList[id]
            // console.log('convertedId: ' + id + ' => ' + convertedId)
            stock = strKey && strKey.length > 0 && this.stockList[convertedId] && this.stockList[convertedId][strKey] ? this.stockList[convertedId][strKey] : null
          }
        }
        // res 1: 在庫あり, -1: 売り止め, 0: 欠品中

        // リストにない場合 スルー
        if (!stock) {
          // console.log('stock not found', id, strKey)
          result.res = 1
        } else {
          // 以下で在庫判定

          // 残り数 文字列を数値に変換
          result.rest = parseInt(stock.cnt_remain)

          if (result.rest > 0) {
            result.res = 1
          }
          // soldout
          if (this.showSoldOut && stock.is_soldout === true) {
            result.res = 0
            result.message = '欠品中'
          } else {
            if (result.rest < 1) { // 残り数がない場合
              result.res = 0
              result.message = '欠品中'
            } else if (result.rest < 5) { // 5個以下の場合
              result.message = '僅少'
            }
          }
        }
        if (result.res !== 1 && soldoutMessages?.[sizeKey]) {
          result.additionalMessage = soldoutMessages[sizeKey]
        }
      }
      // soldout も allocate_stocksもfalseなら常に在庫あり表示
      if (!this.showStocks && !this.showSoldOut) {
        result.res = 1
        result.rest = 9999
      }

      return result
    },
    async getRecSizes () {
      this.reRendering = this.reRendering > 8 ? 1 : this.reRendering + 1
      var data = this.params
      data.ui = this.$root.$route.query.ui ? this.$root.$route.query.ui : ''
      await axios.post(this.$root.baseURL + 'getRecSizes', { params: data
      }).then(response => {
        this.recSizes = response.data
        // console.log('getRecSizes', this.recSizes)
        // if (data.item === 'snb') { this.params.shoe = this.recSizes.shoe_size_board }
        // if (data.item === 'ski') { this.params.shoe = this.recSizes.shoe_size_ski }
        // if (data.item === 'ssk') { this.params.shoe = this.recSizes.shoe_size }
      }).catch(error => { console.log('getRecSizes', error) }).finally(() => {
        this.checkSetItems()
      })
    },
    refreshRequest () {
      let tmp = []
      if (this.req['wear'] && this.req['wear'].length > 0) {
        tmp.push(this.req['wear'])
      }
      // console.log(this.req[this.params.item])
      if (this.req[this.params.item] && this.req[this.params.item].length > 0) {
        tmp.push(this.req[this.params.item])
      }
      if (this.req['weight'] && this.req['weight'].length > 0) {
        tmp.push('[体重:' + this.req['weight'] + ' kg]')
      }
      if (this.req['text'] && this.req['text'].length > 0) {
        tmp.push(this.req['text'])
      }
      // stance 書き込み スノボのみ
      if (this.params.stance && this.params.item === 'snb') {
        tmp.push('スタンス:' + this.params.stance)
      }
      this.params.request = tmp.join(',')
      // console.log(this.params.request)
    },
    setRequest (group, value) {
      if (this.req[group] === value) {
        this.req[group] = ''
      } else {
        this.req[group] = value
      }
      this.refreshRequest()
    },
    requestExists (value) {
      return this.params.request.indexOf(value) >= 0
    },
    refreshTotalPrice () {
      // console.log('refreshTotalPrice')
      let totalPrice = 0

      if (this.params.itemCategory) {
        totalPrice = totalPrice + parseInt(this.prices[this.params.itemCategory])
      }
      // console.log('items', this.params.rentalItems)
      if (Object.keys(this.params.rentalItems).length > 0) {
        this.$_.each(this.params.rentalItems, function (item) {
          // console.log('item', item.name, ', ', item.price, ' * ', item.num)
          totalPrice = totalPrice + parseInt(item.price) * parseInt(item.num)
        })
      }
      this.totalPrice = totalPrice
    },
    setValues () {
      // console.log('Member::setValues')
      // console.log('selectOptions', this.$root.$store.state.selectOptions)
      this.membersCount = this.$root.$store.state.members.length + 1
      this.enableName = this.mode === 'add' ? this.membersCount === 1 : this.params.isRepresentative
      if (!this.enableName) {
        let member = this.$root.$store.state.members[0]
        this.representative = member.last_name + member.first_name
        let enable = this.$root.serviceSetting.enable_name.value
        this.enableName = enable === '' ? true : enable
      }
      // let stock = this.$root.$store.state.optionValues.enable_allocate_stocks
      let stock = this.$root.serviceSetting.enable_allocate_stocks.value === 'true'
      this.showSoldOut = this.$root.serviceSetting.stock_soldout.value === 'master'
      this.showStocks = stock
      if (this.$root.$route.query.showStocks === '1') {
        // console.log('showStocks: true')
        this.showStocks = true
      }
      let keys = ['sex', 'ages']
      let apiKeys = ['SEX', 'AGE']

      if (this.$root.$store.state.selectOptions['WGT'] !== undefined && Object.keys(this.$root.$store.state.selectOptions['WGT']).length > 0) {
        let tmp = {}
        this.$root.$store.state.selectOptions['WGT'].forEach(data => {
          tmp[data.value] = data.name
        })
        this.selectOptions['WGT'] = tmp
      }
      if (this.$root.$store.state.selectOptions['SKR'] !== undefined && Object.keys(this.$root.$store.state.selectOptions['SKR']).length > 0) {
        // console.log('data', this.$root.$store.state.selectOptions['SKR'])
        let tmp = {}
        this.$root.$store.state.selectOptions['SKR'].forEach(data => {
          tmp[data.value] = data.name
        })
        this.selectOptions['SKR'] = tmp
      }
      for (var i = 0; i < keys.length; i++) {
        var array = []
        if (this.$root.$store.state.selectOptions[apiKeys[i]]) {
          this.$root.$store.state.selectOptions[apiKeys[i]].forEach(date => {
            array.push(date.value)
          })
        }
        this.selectOptions[keys[i]] = array
      }
      // console.log('HEI', this.$root.$store.state.selectOptions)
      let height = this.$root.$store.state.selectOptions.HEI
      this.heightMin = height[0].value
      if (this.heightMin.indexOf('0') === 0) {
        this.heightMin = this.heightMin.slice(1)
      }
      this.heightMax = height[height.length - 1].value
      let shoe = this.$root.$store.state.selectOptions.SHO
      this.shoeMin = shoe[0].value
      this.shoeMax = shoe[shoe.length - 1].value
    },
    async getShareSizes () {
      let _self = this
      axios.post(this.$root.baseURL + 'getShareSizes', { params: Object.keys(this.stockList)
      }).then(response => {
        _self.shareSizesList = response.data
      }).catch(error => { console.log('getShareSizes', error) })
    }
  }
}
</script>
<style scoped>
  .text-transparent {
    color: transparent;
  }
  .btn-inactive {
    border-color: #ccc;
    color: #ccc;
  }
  .items-wrapper {
    position: relative;
  }
  .itemLoading {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(255,255,255,0.8);
    width: 100%;
    height: 100%;
    z-index: 999;
  }
  .itemLoading .loading-message {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  .btn-fluc {
    background-color: #ececec;
    border-radius: 10%;
  }
  .package-item .item-pictogram{
    display: inline-block;
    width: 25px;
    height: 25px;
    text-align: center;
  }
</style>
<style>
.additional-message {
  font-size: 80%;
  width: 100%;
  text-align: right;
}
.btn-primary:disabled {
  background-color: #ccc;
  color: #999;
  border: 0;
}
</style>
